import React, { useEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import { ModalGenerico } from '../../../../components/ui'
import { ACTIONS } from '../../../../constants'
import { useSelector } from 'react-redux'

export const ModalAllergicSymptomp = ({
  handleSubmit,
  handlerAction,
  action,
  reset,
  control,
  errors,
  setValue
}) => {
  const { activeAllergicSymptom } = useSelector((state) => state.ui)

  useEffect(() => {
    if (activeAllergicSymptom) {
      setValue('nombre', activeAllergicSymptom.nombre)
      setValue('id', activeAllergicSymptom.id)
    }
  }, [activeAllergicSymptom])

  return (
    <ModalGenerico
      title="Sintomas de Alergias"
      buttonCustom={() => (
        <Button
          variant="primary "
          size="md"
          style={{
            minWidth: '15%'
          }}
          onClick={handleSubmit(handlerAction)}
        >
          {action === ACTIONS.SAVE ? 'Guardar' : 'Actualizar'}
        </Button>
      )}
      closeButtonAction={reset}
    >
      <Form>
        <Form.Group className="mb-2">
          <Form.Label>Nombre del sintoma</Form.Label>
          <Controller
            control={control}
            name="nombre"
            render={({ field }) => (
              <Form.Control type="text" placeholder="Nombre del sintoma..." {...field} />
            )}
          />
          {errors.nombre && (
            <Form.Text className="text-danger">{errors?.nombre?.message}</Form.Text>
          )}
        </Form.Group>
      </Form>
    </ModalGenerico>
  )
}
